module.exports = __webpack_public_path__ + "img/sidebar-resources-ico-wht.b35f3408.svg";